//  ANNOUNCEMENT BAR 

class announcementScroll extends HTMLElement {
  constructor() {
    super();
    this.config = {
      moveTime: parseFloat(this.dataset.speed), 
      space: 100, 
    };
    this.promotion = this.querySelector('.promotion');
  }

}

customElements.define('announcement-scroll', announcementScroll);
let announcementSwipers = [];

function initAnnouncementSwipers() {
  // Destroy existing swipers before re-init
  announcementSwipers.forEach(swiper => swiper.destroy(true, true));
  announcementSwipers = [];

  const announcements = document.querySelectorAll(".js-announcement-carousel");

  // Reset CSS vars
  document.documentElement.style.setProperty('--annoouncement-height', `0px`);
  // document.documentElement.style.setProperty('--anouncement-scroll-height', `0px`);
  const announcementBar = document.querySelector('.utility-bar');
      if (announcementBar) {
        document.documentElement.style.setProperty('--anouncement-scrolling-height', `${announcementBar.offsetHeight}px`);
      }
      else{
          document.documentElement.style.setProperty('--anouncement-scrolling-height', `0`);
      }

  announcements.forEach(function (el, index) {
    el.classList.add(`s${index}`);      

    const swiper = new Swiper(`.js-announcement-carousel.s${index}`, {
      slidesPerView: 1,
      autoHeight: false,
      loop: true,
      effect: "fade",
      autoplay: (el.dataset.autoplay === 'true')
        ? { 
            delay: parseInt(el.dataset.speed) || 3000,
            disableOnInteraction: false
          }
        : false,
      speed: 300,
      on: {
        afterInit: function () {
          const announcementBar = document.querySelector('.utility-bar');
          if (announcementBar) {
            document.documentElement.style.setProperty('--annoouncement-height', `${announcementBar.offsetHeight}px`);
            document.documentElement.style.setProperty('--anouncement-scroll-height', `${announcementBar.offsetHeight}px`);
          }
        }
      }
    });

    announcementSwipers.push(swiper);
  });
  window.addEventListener("scroll", () => {
    if(window.scrollY > 36){
        document.documentElement.style.setProperty('--anouncement-scrolling-height', `0px`);
    }
    else{
      if (announcementBar) {
        document.documentElement.style.setProperty('--anouncement-scrolling-height', `${announcementBar.offsetHeight}px`);
      }
    }
  });

}

// Init on page load
document.addEventListener('DOMContentLoaded', initAnnouncementSwipers);

// Enable live updates inside Shopify editor
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.js-announcement-carousel')) {
      initAnnouncementSwipers();
    }
  });

  document.addEventListener('shopify:section:select', (event) => {
    if (event.target.querySelector('.js-announcement-carousel')) {
      initAnnouncementSwipers();
    }
  });

  document.addEventListener('shopify:block:select', (event) => {
    if (event.target.closest('.js-announcement-carousel')) {
      initAnnouncementSwipers();
    }
  });
}


class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.countdownElement = this.querySelector('.announcement-bar__countdown');
    if (!this.countdownElement) return;

    const countdownDateStr = this.countdownElement.dataset.countdownDate;
    const countdownTimerStr = this.countdownElement.dataset.countdownTime;
    if (!countdownDateStr && !countdownTimerStr) return;
    const [month, day, year] = countdownDateStr.trim().split('-'); 
    const formattedDate = `${year}-${month}-${day}`;
    const fullDateTime = `${formattedDate}T${countdownTimerStr}`;
    this.countdownDate = new Date(fullDateTime).getTime();
    this.countdownTimer = this.countdownElement.querySelector('.countdown-timer');
    this.countdownText = this.countdownElement.querySelector('.countdown-text');
    this.countdownExpired = this.countdownElement.querySelector('.countdown-expired');
    this.bannerLink = this.countdownElement.querySelector('.banner_link');
    this.slide_link = this.countdownElement.querySelector('.slide-link');

    this.updateCountdown();
    this.intervalId = setInterval(() => this.updateCountdown(), 1000);
  }

  disconnectedCallback() {
    if (this.intervalId) clearInterval(this.intervalId);
  }

  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.countdownDate - now;    

    if (distance < 0) {
      if (this.countdownTimer) this.countdownTimer.style.display = 'none';
      if (this.countdownText) this.countdownText.style.display = 'none';
      if (this.countdownExpired) this.countdownExpired.style.display = 'flex';
      if (this.bannerLink) this.bannerLink.style.display = 'none';
      if ( this.slide_link) this.slide_link.style.display = 'none';
      return;
    }

    if (this.countdownTimer) this.countdownTimer.style.display = 'flex';
    if( this.slide_link) this.slide_link.style.display = 'flex'

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    if (isNaN(days) || isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
      const swiperSlide = this.closest('.swiper-slide');  
      swiperSlide.remove() ;
      return;
    }
    
    this.countdownElement.querySelector('.countdown-days').textContent = days.toString().padStart(2,"0");
    this.countdownElement.querySelector('.countdown-hours').textContent = hours.toString().padStart(2,"0");
    this.countdownElement.querySelector('.countdown-minutes').textContent = minutes.toString().padStart(2,"0");
    this.countdownElement.querySelector('.countdown-seconds').textContent = seconds.toString().padStart(2,"0");
  }
}

customElements.define('countdown-timer', CountdownTimer);


class ScrollingAnnouncement extends HTMLElement {
  constructor() {
    super();

    this.config = {
      moveTime: parseFloat(this.dataset.speed), 
      space: 100, 
    };

    this.promotion = this.querySelector('.promotion');
    this.init();      
    const announcementBar = this.closest('.utility-bar');
    
      if (announcementBar) {
        document.documentElement.style.setProperty('--anouncement-scroll-height', `${announcementBar.offsetHeight}px`);
      }
      else{
        document.documentElement.style.setProperty('--anouncement-scroll-height', `0`);
      }
  }

  init() {
    if (this.childElementCount === 1) {
      this.promotion.classList.add('promotion--animated');

      for (let index = 0; index < 20; index++) {
        this.clone = this.promotion.cloneNode(true);
        this.clone.setAttribute('aria-hidden', true);
        this.appendChild(this.clone);

        const imageWrapper = this.clone.querySelector('.promotion__item');
        if (imageWrapper) {
          imageWrapper.classList.remove('loading');
        }
      }

      const animationTimeFrame = this.config.moveTime;
      this.style.setProperty('--duration', `${animationTimeFrame}s`);

      // pause when out of view
      const observer = new IntersectionObserver((entries, _observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.scrollingPlay();
          } else {
            this.scrollingPause();
          }
        });
      }, {rootMargin: '0px 0px 50px 0px'});

      observer.observe(this);

      // pause on hover
      this.addEventListener('mouseenter', () => this.scrollingPause());
      this.addEventListener('mouseleave', () => this.scrollingPlay());
      this.closest('.utility-bar')?.addEventListener('mouseenter', () => this.scrollingPause());
      this.closest('.utility-bar')?.addEventListener('mouseleave', () => this.scrollingPlay());
    }
  }

  scrollingPlay() {
    this.classList.remove('scrolling-promotion--paused');
  }

  scrollingPause() {
    this.classList.add('scrolling-promotion--paused');
  }
}
customElements.define('scrolling-announcement', ScrollingAnnouncement);